module.exports = __webpack_public_path__ + "static/media/illustration-section-01.ea694903.svg";